<template>
  <div>
    <v-row dense>
      <v-col cols="12">
        <v-subheader class="body-1 grey lighten-4 text--primary">
          <v-icon>
            mdi-wallet-bifold-outline
          </v-icon>
          <span class="ml-2">Pagamento</span>
        </v-subheader>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="6">
          <px-select-enum dense
                          label="Forma de pagamento"
                          class="required rounded-tag-small"
                          v-model="negociacao.novaFormaPagemento"
                          :items="formasPagamentos"
                          :error="$v.negociacao.novaFormaPagemento.$error"
                          @blur="$v.negociacao.novaFormaPagemento.$touch()"
                          @change="onChangeFormaPagamento"/>
      </v-col>
      <v-col cols="12" sm="6">
        <px-autocomplete-prazo-pagamento dense
                                         label="Prazo de pagamento"
                                         :class="prazoClass"
                                         :disabled="isAvista"
                                         :error="$v.negociacao.novoPrazoPagamento.$error"
                                         @blur="$v.negociacao.novoPrazoPagamento.$touch()"
                                         v-model="negociacao.novoPrazoPagamento"/>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-subheader class="body-1 grey lighten-4 text--primary">
          <v-icon>
            mdi-truck-fast-outline
          </v-icon>
          <span class="ml-2">Frete</span>
        </v-subheader>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="6">
        <px-select-enum dense
                        label="Tipo de frete"
                        class="required rounded-tag-small"
                        v-model="negociacao.novoTipoFrete"
                        :items="tiposFretes"
                        :error="$v.negociacao.novoTipoFrete.$error"
                        @blur="$v.negociacao.novoTipoFrete.$touch()"
                        @change="onChangeTipoFrete"/>
      </v-col>
      <v-col cols="12" sm="6">
        <px-input-currency
          dense
          label="Valor do frete"
          class="required rounded-tag-small"
          :disabled="isFob"
          :options="configuracaoMoeda"
          v-model="negociacao.novoTotalTransporte"/>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <px-input-number dense
                         label="Prazo de embarque (Dias úteis)"
                         class="required rounded-tag-small"
                         v-model="negociacao.novoPrazoEntrega"
                         :error="$v.negociacao.novoPrazoEntrega.$error"
                         @blur="$v.negociacao.novoPrazoEntrega.$touch()"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { FormaPagamento, TipoFrete } from 'px-business-components';
import { required, requiredIf } from 'vuelidate/lib/validators';
import moedaMixin from '@/mixins/moeda-mixin';

export default {
  mixins: [moedaMixin],
  props: {
    negociacao: Object,
    resposta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      formasPagamentos: FormaPagamento.values,
      tiposFretes: TipoFrete.values,
    };
  },
  computed: {
    moeda() {
      return this.resposta.moeda;
    },
    isAvista() {
      return this.negociacao.novaFormaPagemento !== FormaPagamento.keys.A_PRAZO.key;
    },
    isFob() {
      return this.negociacao.novoTipoFrete === TipoFrete.keys.FOB.key;
    },
    prazoClass() {
      return this.isAvista ? 'rounded-tag-small' : 'required rounded-tag-small';
    },
  },
  methods: {
    onChangeFormaPagamento() {
      this.negociacao.novoPrazoPagamento = null;
    },
    onChangeTipoFrete() {
      this.negociacao.novoTotalTransporte = 0;
    },
    validate() {
      this.$v.$touch();
      return this.$v.$invalid;
    },
  },
  validations: {
    negociacao: {
      novaFormaPagemento: {
        required,
      },
      novoPrazoPagamento: {
        required: requiredIf(function () {
          return !this.isAvista;
        }),
      },
      novoTipoFrete: {
        required,
      },
      novoPrazoEntrega: {
        required,
      },
    },
  },
};
</script>
